<template>
    <div>
        <div class="form-group file-area">
            <input type="file" :name="field_name" :id="field_name" @change="readFileProperties"
                   v-bind:required="isReallyRequired"/>
            <div v-bind:class="stateClass"><i :class="icon"> </i> <span v-html="stateText"></span></div>
        </div>
    </div>
</template>

<script>
    let toastr = require('toastr');

    export default {
        data() {
            return {
                state: "default",
                errorMessage: "",
                checked: false,
                fileDisplayName: ''
            }
        },
        props: [
            "file_names",
            "field_name",
            "enforce_filename",
            "icon",
            "isrequired",
            "lesson_code",
        ],
        computed: {
            isReallyRequired() {
                return this.isrequired;
            },
            filename_array() {
                return this.file_names.split(",");
            },
            filetype_array() {
                var file_types = this.file_names.split(",").map(function (item) {
                    return item.split('.').pop();
                });
                return file_types;

            },
            stateClass() {
                return "file-dummy file-dummy-" + this.state;
            },
            stateText() {
                var fileDisplayName = this.fileDisplayName ? this.fileDisplayName : this.filename_array[0];
                var title_color = ((this.isReallyRequired && this.state === 'default') ? "style='color: darkred'" : "");
                var required_marker = ((this.isReallyRequired && this.state === 'default') ? "*" : "");
                return "<b " + title_color + ">" + fileDisplayName + required_marker + "</b><br /> " +
                    (this.state === "success"
                        ? "File seems valid"
                        : this.state === "error"
                            ? this.errorMessage
                            : "Click or drop file here!");
            }
        },
        methods: {
            FileSelectHandler(e) {
                let files = e.target.files || e.dataTransfer.files;
                $("#" + this.field_name).prop("files", e.originalEvent.dataTransfer.files);
            },
            clearFile() {
                _(this.field_name).value = "";
            },
            readFileProperties(e) {

                let files = e.target.files || e.dataTransfer.files;
                if (!files.length) {
                    this.clearFile();
                    return;
                }

                let file = files[0];

                if (this.enforce_filename === "1" && this.filename_array.indexOf(file.name) === -1) {
                    this.errorMessage = 'Faulty file name: ' + file.name;
                    this.clearFile();
                    this.state = "error";
                    return;
                }

                if (this.filetype_array.indexOf(file.name.split('.').pop()) === -1) {
                    this.errorMessage = 'Faulty file type: ' + file.name.split('.').pop();
                    this.clearFile();
                    this.state = "error";
                    return;
                }

                this.fileDisplayName = file.name;

                this.state = "success";
            },

            utf8_decode(string) {
                return decodeURIComponent(escape(string));
            },

            nl2br: function (string) {
                return (string + '').replace(/([^>\r\n]?)(\r\n|\n\r|\r|\n)/g, '$1' + '<br>' + '$2');
            }
        }
    }
</script>